if (!customElements.get('mv-card-sizes')) {
  customElements.define('mv-card-sizes', class extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('product-card, [data-mv-christmas-card]');
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.onColor = (event) => {
        const input = event.target.closest('.mv-card-color-swatches input');
        const button = event.target.closest('.mv-christmas-card__swatch');
        if (input || button) this.update(input ? input.value : button.getAttribute('aria-label'));
      };
      this.card?.addEventListener('change', this.onColor);
      this.card?.addEventListener('click', this.onColor);
      this.update(this.dataset.color);
    }
    disconnectedCallback() {
      this.card?.removeEventListener('change', this.onColor);
      this.card?.removeEventListener('click', this.onColor);
    }
    update(color) {
      this.querySelectorAll('[data-size]').forEach((label) => {
        const matches = this.variants.filter(v => v.size === label.dataset.size && v.color === color);
        const available = matches.some(v => v.available);
        label.hidden = matches.length === 0;
        label.classList.toggle('is-unavailable', !available);
        label.title = label.dataset.size + (available ? '' : ' — indisponible');
      });
    }
  });
}
